import React from 'react';
import PropTypes from 'prop-types';
import { 
    CustomFormCheckbox, 
    CustomFormDate, 
    CustomFormInput, 
    CustomFormRadio, 
    CustomFormSelect, 
    SpinnerLoader
} from '../../atoms';
import classes from './PaymentFormRow.module.scss';

const PaymentFormRow = (props) => {
    const { 
        formRowListData, 
        formik, 
        data, 
    } = props;
    if (formRowListData?.length === 0) return null;
    
    let colClasses = 'col-lg-12 col-md-12';
    if (formRowListData?.length === 2) {
        colClasses = 'col-lg-6 col-md-6';
    } else if (formRowListData?.length > 2) {
        colClasses = 'col-lg-4 col-md-6';
    }

    return (
        <div className="row">
            {formRowListData?.map((field, index) => {
                return (
                    <div key={`${field?.input_id}`} className={`${colClasses} col-sm-12`}>

                        {field?.is_active && !['stud_bd_student_uuid', 'customer_mobile', 'customer_email'].includes(field?.input_id) && (field?.input_type === 'text' || field?.input_type === 'email') ? 
                            (<CustomFormInput inputData={field || null} formik={formik} />)
                        : null}

                        {(field?.is_active && field?.input_type === 'select') ? 
                            (<CustomFormSelect inputData={field || null} formik={formik} data={data} />)
                        : null}

                        {(field?.is_active && field?.input_type === 'radio') ? 
                            (<CustomFormRadio inputData={field || null} formik={formik} />)
                        : null}

                        {(field?.is_active && field?.input_type === 'checkbox') ? 
                            (<CustomFormCheckbox inputData={field || null} formik={formik} />)
                        : null}

                        {(field?.is_active && field?.input_type === 'date') ? 
                            (<CustomFormDate inputData={field || null} formik={formik} />)
                        : null}
                    </div>
                )
            })}
        </div>
    )
}

PaymentFormRow.propTypes = {}

export default PaymentFormRow;